export enum ConnectorsCount {
  NO_OF_CONNECTORS = 8
}

export const NOT_USED_CONNECTORS = {
  connectors: ['servicenow', 'namely', 'sagefinancials', 'sageintacct']
};
